import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import getHighlightedTextParts from '../helpers/get-highlighted-text-parts';

const { Mark } = designSystem;

const SearchHighlight = ({ text, searchQuery = '' }) => (
  <>
    {getHighlightedTextParts(searchQuery, text).map((part, index) => (
      // eslint-disable-next-line yola/react/no-array-index-key
      <Mark key={index} isHighlighted={part.isMatch}>
        {part.text}
      </Mark>
    ))}
  </>
);

SearchHighlight.propTypes = {
  text: PropTypes.string.isRequired,
  searchQuery: PropTypes.string,
};

export default SearchHighlight;
